import { ItemTypeConsts } from 'client/util/Constants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const DirectoriesMainPanel = () => import('client/directories/DirectoriesMainPanel.vue');
const AdBridgeAsidePanel = () => import('client/directories/ActiveDirectory/AdBridgeAsidePanel.vue');

const { activeDirectory } = ItemTypeConsts;

const directoryProps = {
  activeDirectoryAsidePanel: {
    isExpanded: true,
    itemType: activeDirectory,
  },
  mainPanel: {
    isAsideOpen: false,
    itemType: ItemTypeConsts.activeDirectory,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Active Directory Integration',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.activeDirectory].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.activeDirectory].tooltipText,
  },
};

export default [
  {
    path: '/directories/active-directory',
    name: 'activeDirectory',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
    },
    props: {
      inDetailsAsidePanel: false,
      mainPanel: directoryProps.mainPanel,
    },
  },
  {
    path: '/directories/active-directory/:id/details',
    name: 'activeDirectoryDetails',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: AdBridgeAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.activeDirectoryAsidePanel,
        itemId: route.params.id,
      }),
    },

  },
];
